import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semobold py-4 fs-6 w-325px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  alt: "Logo",
  src: "media/avatars/blank.png"
}
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_8 = { class: "fw-bold d-flex text-break align-items-center fs-5" }
const _hoisted_9 = { class: "text-break text-muted text-hover-primary fs-8" }
const _hoisted_10 = { class: "fw-bold d-flex text-break align-items-center fs-8 mt-3" }
const _hoisted_11 = { class: "svg-icon svg-icon-3 me-2" }
const _hoisted_12 = { class: "text-break text-muted text-hover-primary mt-1 fs-9" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_14 = { class: "menu-item px-5" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Perfil ")
const _hoisted_16 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (
              this.user &&
              this.user.User &&
              this.user.User.UsuarioDado &&
              this.user.User.UsuarioDado.foto
            )
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                alt: "Logo",
                src: this.$utils.getUrl() + this.user.User.UsuarioDado.foto
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", _hoisted_6))
        ]),
        (this.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(this.user.User.nome), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(this.user.User.usuario), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/ecommerce/ecm008.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(this.user.User.Emitente.nome), 1)
              ]),
              _createElementVNode("div", _hoisted_12, " CNPJ : " + _toDisplayString(this.formatCNPJ(this.user.User.Emitente.cnpj)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      (this.user)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/configuracoes/usuarios/editar/' + this.user.User.id,
            class: "menu-link px-5"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sair ")
    ])
  ]))
}